import { ComponentCustomProperties } from 'vue';
import { CompassApi } from '@/api-client/CompassApiProxy';

export default class Toast {
	public static mainAppComponent: ComponentCustomProperties;

	static ApiError(mainMesssage: string, error: Error, duration: number | undefined = undefined): void {
		this.mainAppComponent.$toast.add({
			severity: 'error',
			life: duration,
			summary: mainMesssage,
			detail: CompassApi.translateError("", error, true)
		});
	}

	static Error(title: string, content: string, duration: number | undefined = undefined): void {
		this.mainAppComponent.$toast.add({
			severity: 'error',
			life: duration,
			summary: title,
			detail: content
		});
	}

	static Warning(title: string, content: string, duration: number | undefined = 2000): void {
		this.mainAppComponent.$toast.add({
			severity: 'warn',
			life: duration,
			summary: title,
			detail: content
		});
	}

	static Info(title: string, content: string, duration: number | undefined = 2000): void {
		this.mainAppComponent.$toast.add({
			severity: 'info',
			life: duration,
			summary: title,
			detail: content
		});
	}

	static Success(title: string, content: string, duration: number | undefined = 2000): void {
		this.mainAppComponent.$toast.add({
			severity: 'success',
			life: duration,
			summary: title,
			detail: content
		});
	}

	static RemoveAllGroups(): void {
		this.mainAppComponent.$toast.removeAllGroups();
	}
}